/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerCampaign} from '../api'

export const useMutationRegisterCampaign = createReactQueryMutationHook('registerCampaign', registerCampaign)
